import { useAoApi } from "@lending/lib/api";

function useSubmitConsumerApplicationMutation() {
  const $aoApi = useAoApi();

  return $aoApi.useMutation("post", "/v2/account_opening/consumer/applications/{uuid}/submit/");
}

export { useSubmitConsumerApplicationMutation };
